import React from 'react'
import Landing from "../components/Landing";
import AboutMe from "../components/AboutMe";
import {PageWrapper} from "../components/Styles/pageWrapper";
import ContactForm from "../components/ContactForm";
import {FormWrapper} from "../components/Styles/input";
import MyWork from "../components/MyWork";

const Home = () => {
  return (
    <PageWrapper>
      <Landing />
      <MyWork />
      <AboutMe />
      <FormWrapper id="contact-me">
        <ContactForm />
      </FormWrapper>
    </PageWrapper>
  );
}

export default Home;
